export class ConvertUtils {
    static ToInt(value: any) {
        let intVal = 0;
        try {
            intVal = parseInt(value);
        } catch (ex) { /* empty */ }
        return intVal >= 0 ? intVal : 0;
    }
}


export function convertEmailStringToArray(emailString: string): string[] {
    return emailString
      .split(' or ')
      .map(email => email.trim());
  }